import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useMemo, useState } from "react";
const DRAWER_BODY_CLASSNAME_ACTIVE_STATUS = "drawerActive";
export const DrawerContext = createContext(null);
export const DrawerProvider = ({ onCancelCallback, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const openDrawer = () => {
        setIsOpen(true);
    };
    const closeDrawer = () => {
        setIsOpen(false);
        onCancelCallback && onCancelCallback();
    };
    const subscribeToHotkeys = () => {
        const handleEscKey = (event) => {
            if (event.key === "Escape") {
                setIsOpen(false);
            }
        };
        document.addEventListener("keydown", handleEscKey, false);
        return {
            unsubscribeFromHotkeys: () => document.removeEventListener("keydown", handleEscKey, false),
        };
    };
    useEffect(() => {
        document.body.classList.toggle(DRAWER_BODY_CLASSNAME_ACTIVE_STATUS, isOpen);
        return () => {
            document.body.classList.remove(DRAWER_BODY_CLASSNAME_ACTIVE_STATUS);
        };
    }, [isOpen]);
    useEffect(() => {
        const { unsubscribeFromHotkeys } = subscribeToHotkeys();
        return () => unsubscribeFromHotkeys();
    }, []);
    const context = useMemo(() => ({
        isOpen,
        openDrawer,
        closeDrawer,
    }), [isOpen]);
    return _jsx(DrawerContext.Provider, { value: context, children: children });
};
//# sourceMappingURL=DrawerProvider.js.map